import React, { useEffect, useState } from "react";

const rx = (re) => (l) => re.test(String(l.result_code_description || l.test_name || ""));
// Real counts from the loaded chart; terms with no count still show as part of the read.
export function chartReadTerms(D) {
  const d = D || {}, labs = d.elabs || [], n = (a) => (Array.isArray(a) ? a.length : 0);
  const icd = new Set((d.problems || []).map((p) => p.icd10_code).filter(Boolean)).size;
  return [
    { k: "Visits", n: n(d.encounters) },
    { k: "ICD-10", n: icd },
    { k: "Dx", n: n(d.problems) },
    { k: "CPT", n: null },
    { k: "Rx", n: n(d.erx) },
    { k: "Labs", n: n(labs) },
    { k: "Lipids", n: labs.filter(rx(/lipid|ldl|hdl|cholesterol|triglycer/i)).length },
    { k: "HbA1c", n: labs.filter(rx(/a1c|hemoglobin a1/i)).length },
    { k: "eGFR", n: labs.filter(rx(/egfr|gfr|creatinine/i)).length },
    { k: "Vitals", n: n(d.all_vitals) },
    { k: "BP trends", n: null },
    { k: "Allergies", n: n(d.history_allergies) },
    { k: "History", n: n(d.history_medical) + n(d.history_surgical) + n(d.history_family) },
    { k: "Appointments", n: n(d.appointments) },
  ];
}

const VERB = { summary: "Summarising", lumina: "Lumina is reading", echo: "Drafting patient messages from" };

export function AiProgress({ panel, terms, slim }) {
  const [t, setT] = useState(0);
  useEffect(() => { const s = Date.now(); const id = setInterval(() => setT((Date.now() - s) / 1000), 120); return () => clearInterval(id); }, []);
  const pct = Math.min(94, 100 * (1 - Math.exp(-t / 14)));
  const list = terms || [];
  const idx = list.length ? Math.floor(t / 0.65) % list.length : 0;
  const pass = list.length ? Math.floor(t / 0.65) >= list.length : false;
  const cur = list[idx];
  if (slim) return <div className="aip-slim" data-testid="ai-progress-slim"><i style={{ width: `${pct}%` }} /></div>;
  return (
    <div className="aip" data-testid="ai-progress">
      <div className="aip-head">
        <span className="aip-verb">{VERB[panel] || "Reading"} the chart</span>
        <span className="aip-pct" data-testid="ai-progress-pct">{Math.round(pct)}%</span>
      </div>
      <div className="aip-bar"><i className={`aip-fill aip-${panel}`} style={{ width: `${pct}%` }} /></div>
      <div className="aip-now" data-testid="ai-progress-now">
        {cur ? <>Reading <b key={cur.k} className="aip-word">{cur.k}</b>{cur.n ? <span className="aip-n"> · {cur.n} on this chart</span> : null}</> : "Reading"}
      </div>
      <div className="aip-chips">
        {list.map((x, i) => {
          const st = i === idx ? "on" : pass || i < idx ? "done" : "";
          return (
            <span key={x.k} className={`aip-chip ${st}`} data-testid={`ai-progress-chip-${i}`}>
              {st === "done" ? <span className="aip-ck">✓</span> : null}{x.k}{x.n ? <em>{x.n}</em> : null}
            </span>
          );
        })}
      </div>
    </div>
  );
}

export const AI_PROGRESS_CSS = `
.aip{background:#fff;border:1px solid #ECECEF;border-radius:14px;padding:18px 20px 16px}
.aip-head{display:flex;align-items:baseline;justify-content:space-between;margin-bottom:10px}
.aip-verb{font:750 14px Inter,system-ui,sans-serif;color:#141412}
.aip-pct{font:700 12px Inter,system-ui,sans-serif;color:#6C6C69;font-variant-numeric:tabular-nums}
.aip-bar{height:6px;border-radius:999px;background:#F1F1F4;overflow:hidden}
.aip-fill{display:block;height:100%;border-radius:999px;transition:width .3s ease;background-size:200% 100%;animation:aipsh 1.4s linear infinite}
.aip-summary{background-image:linear-gradient(90deg,#7FAEE6,#2F6FB3,#7FAEE6)}
.aip-lumina{background-image:linear-gradient(90deg,#B4A1EC,#5B3FB8,#B4A1EC)}
.aip-echo{background-image:linear-gradient(90deg,#7CCFC2,#0F7A6E,#7CCFC2)}
@keyframes aipsh{from{background-position:200% 0}to{background-position:0 0}}
.aip-now{margin:14px 0 12px;font:500 13px Inter,system-ui,sans-serif;color:#6C6C69;min-height:20px}
.aip-word{display:inline-block;color:#141412;font-weight:750;animation:aipin .3s ease}
@keyframes aipin{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}
.aip-n{color:#9B9B97}
.aip-chips{display:flex;flex-wrap:wrap;gap:6px}
.aip-chip{display:inline-flex;align-items:center;gap:5px;padding:4px 10px;border-radius:999px;border:1px solid #ECECEF;background:#FAFAF9;font:600 11.5px Inter,system-ui,sans-serif;color:#B5B5B1;transition:background-color .2s,color .2s,border-color .2s,transform .2s}
.aip-chip em{font-style:normal;font-weight:700;font-size:10.5px;opacity:.8}
.aip-chip.done{color:#48484A;background:#fff;border-color:#E3E3E6}
.aip-chip.on{color:#fff;background:#141412;border-color:#141412;transform:translateY(-1px)}
.aip-ck{font-size:10px;color:#0E9F6E}
.aip-slim{height:3px;border-radius:999px;background:#F1F1F4;overflow:hidden;margin:0 0 14px}
.aip-slim i{display:block;height:100%;background:#141412;opacity:.55;transition:width .3s ease}
`;
